import Banner from './assets/images/banner-preview.webp';
import BannerRetina from './assets/images/banner-preview-retina.webp';
import BannerTopLeft from './assets/images/banner-top-left.webp';
import BannerTopLeftRetina from './assets/images/banner-top-left-retina.webp';
import BannerTopRight from './assets/images/banner-top-right.webp';
import BannerTopRightRetina from './assets/images/banner-top-right-retina.webp';
import BannerMiddleTop from './assets/images/banner-middle-top.webp';
import BannerMiddleTopRetina from './assets/images/banner-middle-top-retina.webp';
import BannerMiddleBottom from './assets/images/banner-middle-bottom.webp';
import BannerMiddleBottomRetina from './assets/images/banner-middle-bottom-retina.webp';
import BannerMiddleLeft from './assets/images/banner-middle-left.webp';
import BannerMiddleLeftRetina from './assets/images/banner-middle-left-retina.webp';
import BannerMiddleRight from './assets/images/banner-middle-right.webp';
import BannerMiddleRightRetina from './assets/images/banner-middle-right-retina.webp';
import BannerBottomLeft from './assets/images/banner-bottom-left.webp';
import BannerBottomLeftRetina from './assets/images/banner-bottom-left-retina.webp';
import BannerBottomRight from './assets/images/banner-bottom-right.webp';
import BannerBottomRightRetina from './assets/images/banner-bottom-right-retina.webp';

export const homeImages = {
    banner: {
        url: '/kategoria/217-smartband.html',
        name: 'Modne smarbandy',
        image: Banner,
        imageRetina: BannerRetina
    },

    bannerTopLeft: {
        url: '/kategoria/2029-kontrolery-do-playstation.html',
        name: 'Sprawdzone kontrolery',
        image: BannerTopLeft,
        imageRetina: BannerTopLeftRetina
    },

    bannerTopRight: {
        url: '/kategoria/20-tablety.html ',
        name: 'Popularne tablety',
        image: BannerTopRight,
        imageRetina: BannerTopRightRetina
    },

    bannerMiddleTop: {
        url: '/kategoria/307-ekspresy-do-kawy.html',
        name: 'Ekspresy do kawy',
        image: BannerMiddleTop,
        imageRetina: BannerMiddleTopRetina
    },

    bannerMiddleBottom: {
        url: '/sub-departament/568-sprzatanie.html',
        name: 'Małe AGD',
        image: BannerMiddleBottom,
        imageRetina: BannerMiddleBottomRetina
    },

    bannerMiddleLeft: {
        url: '/sub-departament/9-sprzet-wolnostojacy.html',
        name: 'Duże AGD',
        image: BannerMiddleLeft,
        imageRetina: BannerMiddleLeftRetina
    },

    bannerMiddleRight: {
        url: '/dom-i-wnetrze.html',
        name: 'Dom i wnętrza',
        image: BannerMiddleRight,
        imageRetina: BannerMiddleRightRetina
    },

    bannerBottomLeft: {
        url: '/kategoria/2217-rolki.html',
        name: 'Rolki dla każdego',
        image: BannerBottomLeft,
        imageRetina: BannerBottomLeftRetina
    },

    bannerBottomRight: {
        url: '/sub-departament/75-sporty-zespolowe.html',
        name: 'Sporty zespołowe',
        image: BannerBottomRight,
        imageRetina: BannerBottomRightRetina
    }
};
